/**
 * Every user-facing string on the expenses screen, in one place.
 *
 * Taken from the phone word for word, which is why the language is mixed: the
 * rule for this app is English everywhere the phone is English, and the
 * phone's own Somali kept wherever it has some. So the screen reads "Total
 * Expense" and "Transactions", and the button that opens the form still says
 * "Abuur Expense Cusub" because that is what it says in the shop.
 *
 * Apostrophes are avoided in these values on purpose: they sit in JSX text and
 * a stray one has broken the build before.
 */
export const COPY = {
  title: 'Expenses',

  // Header
  totalExpense: 'Total Expense',
  categories: 'Categories',
  transactions: 'Transactions',

  // Filtering the list by a category from the breakdown
  showAll: 'Show all',
  inCategory: (name) => `Showing ${name}`,
  noneInCategory: (name) => `Nothing under ${name} in this period`,
  add: 'Abuur Expense Cusub',
  manageCategories: 'Categories',
  search: 'Search expenses',

  // Form
  addTitle: 'Add New Expense',
  editTitle: 'Edit Expense',
  amount: 'Amount',
  description: 'Description',
  date: 'Date',
  category: 'Select Category',
  notes: 'Notes',
  paymentType: 'Payment',
  cash: 'cash',
  invoice: 'invoice',
  vendor: 'Vendor',
  selectVendor: 'Select vendor',
  save: 'Save Expense',
  saveEdit: 'Save',
  cancel: 'Cancel',

  // Validation, from the phone's AddExpenseCubit
  amountRequired: 'Amount is required',
  descriptionRequired: 'Description is required',
  vendorRequired: 'Vendor is required for invoice',
  amountInvalid: 'Invalid amount',
  categoryRequired: 'Select a category',
  saveFailed: 'Could not save. Try again.',

  // Delete
  deleteTitle: 'Delete Expense',
  deleteBody: (name) => `Are you sure you want to delete "${name}"?`,
  deleteNote: 'An invoiced expense also removes what it added to the vendor book.',
  delete: 'Delete',

  // Categories dialog
  categoriesTitle: 'Expense Categories',
  categoryName: 'Category name',
  categoryNameRequired: 'Please enter category name',
  addCategory: 'Add',
  saveCategory: 'Save',
  categoryAdded: 'Category added successfully!',
  categoryUpdated: 'Category updated successfully!',
  categoryDeleted: 'Category deleted successfully!',
  deleteCategoryTitle: 'Delete Category',
  deleteCategoryBody: (name) => `Are you sure you want to delete "${name}"?`,
  deleteCategoryNote:
    'Expenses already filed under it keep their amount but lose the category name.',
  noCategories: 'No categories yet',

  // States
  loading: 'Loading expenses…',
  emptyTitle: 'No expenses in this period',
  emptyBody: 'Change the dates, or add the first one.',
  nothingFound: 'Nothing found',
  errorTitle: 'Could not load expenses',
  retry: 'Try again',
  restricted: 'Only a manager or a cashier can open Expenses.',

  // Toasts
  saved: 'Expense saved',
  added: 'Expense added',
  deleted: 'Expense deleted',

  entries: (n) => (n === 1 ? '1 entry' : `${n} entries`),
};
